export enum OwnershipTypes {
  soleOwnership = 'Sole Ownership',
  privateCorporation = 'Private Corporation',
  limitedLiabilityCompany = 'Limited Liability Company',
  nonProfit = 'Nonprofit / Tax Exempt',
  publicCorporation = 'Public Corporation: NYSE/NASDAQ/Etc',
  government = 'Government',
}
